import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/ubuntu/download_staging/698f726ff782d50014b2e768_1782430353367_1f40d799/autofitseafood/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/698f726ff782d50014b2e768_1782430353367_1f40d799/autofitseafood/src/styles/index.css");
